
        import React from 'react';
        import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new SpriteSymbol({
  "id": "arrow.sprite",
  "use": "arrow.sprite-usage",
  "viewBox": "0 0 100 125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 125\" id=\"arrow.sprite\">\n\t<path d=\"M20.8,112.2c0.5,0.5,1.2,0.8,2,0.8s1.5-0.3,2-0.8L72,65c1.1-1.1,1.1-2.9,0-4l0,0L24.8,13.8c-1.1-1.1-2.9-1.2-4-0.1\n\ts-1.2,2.9-0.1,4l0.1,0.1L66,63l-45.2,45.2C19.7,109.3,19.7,111,20.8,112.2L20.8,112.2z\" />\n</symbol>"
});
        sprite.add(symbol);

        const ArrowSpriteSpriteSymbol = props => (
            <svg {...props} viewBox='0 0 100 125'>
                <use xlinkHref='#arrow.sprite' />
            </svg>
        );
        export default ArrowSpriteSpriteSymbol;
  